import { render, staticRenderFns } from "./AppLocaleBreadcrumb.vue?vue&type=template&id=46d74590"
import script from "./AppLocaleBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppLocaleBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports